import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
const icons = { StorageRoundedIcon };

// ==============================|| MENU ITEMS - MASTER DATA ||============================== //

const masterData = {
  id: 'group-master-data',
  type: 'group',
  children: [
    {
      id: 'master-data',
      title: 'Master Data',
      type: 'collapse',
      icon: icons.StorageRoundedIcon,
      children: [
        {
          id: 'tracking',
          title: 'Tracking',
          type: 'collapse',
          icon: icons.StorageRoundedIcon,
          children: [
            {
              id: 'master-country',
              title: 'Master Country',
              type: 'item',
              url: '/master-country',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'working-area',
              title: 'Master Area',
              type: 'item',
              url: '/master-area',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'vendor',
              title: 'Vendor',
              type: 'item',
              url: '/vendor',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'vehicle-type',
              title: 'Vehicle Type',
              type: 'item',
              url: '/vehicle-type',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'vehicle',
              title: 'Vehicle',
              type: 'item',
              url: '/master-vehicle',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-vehicle-license',
              title: 'Vehicle License',
              type: 'item',
              url: '/master-vehicle-license',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'driver',
              title: 'Driver',
              type: 'item',
              url: '/master-driver',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-driver-license',
              title: 'Driver License',
              type: 'item',
              url: '/master-driver-license',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-pit',
              title: 'Master Pit',
              type: 'item',
              url: '/master-pit',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-geofence-library',
              title: 'Master Geofence Library',
              type: 'item',
              url: '/master-geofence-library',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-jetty',
              title: 'Master Jetty',
              type: 'item',
              url: '/master-jetty',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-route',
              title: 'Master Route',
              type: 'item',
              url: '/master-route',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'tyre',
              title: 'Master Tire',
              type: 'item',
              url: '/master-tire',
              icon: icons.StorageRoundedIcon
            }
            // {
            //   id: 'p2h-template-builder',
            //   title: 'P2H Template Builder',
            //   type: 'item',
            //   url: '/p2h-template-builder',
            //   icon: icons.StorageRoundedIcon
            // }
          ]
        },
        {
          id: 'operations-tools',
          title: 'Operation Tools',
          type: 'collapse',
          icon: icons.StorageRoundedIcon,
          children: [
            {
              id: 'company',
              title: 'Company',
              type: 'item',
              url: '/master-company',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-gps',
              title: 'Master GPS',
              type: 'item',
              url: '/master-gps',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'package-menu',
              title: 'Package Menu',
              type: 'item',
              url: '/package-menu',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'master-menu',
              title: 'Menu',
              type: 'item',
              url: '/master-menu',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'user-management',
              title: 'Role',
              type: 'item',
              url: '/user-management',
              icon: icons.StorageRoundedIcon
            },
            {
              id: 'user-and-role',
              title: 'User And Role',
              type: 'item',
              url: '/master-user',
              icon: icons.StorageRoundedIcon
            }
          ]
        }
      ]
    }
  ]
};

export default masterData;
